// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CreditMemoClaimTypesCriteria from './claim-types-criteria';
import CreditMemoCriteriaFooter from './criteria-footer';
import CreditMemoDealerCriteria from '../../../shared/components/dealer-criteria';
import CreditMemoPrimaryInputCriteriaSection from './primary-input-criteria-section';
import CreditMemoSecondaryInputCriteriaSection from './secondary-input-criteria-section';
import Criteria from '../../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';

const CreditMemoReportCriteria = props =>
    <div className='credit-memo-report-criteria'>
        <div className='credit-memo-criteria'>
            <CreditMemoDealerCriteria
                onDealerSelect={props.handleDealerSelect}
                onSelectAllDealers={props.handleAllDealersSelect}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.selectedDealers}
            />
            <CreditMemoPrimaryInputCriteriaSection
                criteria={props.criteria}
                handleCreditMemoNumberInputChange={props.handleCreditMemoSelect}
                handleFirstWorkOrderInput={props.handleFirstWorkOrderInput}
                handlePinInputChange={props.handlePinInputChange}
            />
            <CreditMemoSecondaryInputCriteriaSection
                criteria={props.criteria}
                handleClaimNumberInputChange={props.handleClaimNumberSelect}
                handleCreditMemoIssueDateSelect={props.handleCreditMemoIssueDateSelect}
                handleInvoiceRequestInputChange={props.handleInvoiceRequestInput}
            />
            {props.isSapUp &&
                <CreditMemoClaimTypesCriteria
                    claimTypes={props.criteria.claimTypes}
                    handleAllClaimTypesSelect={props.handleAllClaimTypesSelect}
                    handleClaimTypeSelect={props.handleClaimTypeSelect}
                />
            }
        </div>
        <CreditMemoCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            handleCriteriaReset={props.handleCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateCreditMemoReport}
        />
    </div>;

CreditMemoReportCriteria.displayName = 'CreditMemoReportCriteria';
CreditMemoReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleAllClaimTypesSelect: PropTypes.func.isRequired,
    handleAllDealersSelect: PropTypes.func.isRequired,
    handleClaimNumberSelect: PropTypes.func.isRequired,
    handleClaimTypeSelect: PropTypes.func.isRequired,
    handleCreditMemoIssueDateSelect: PropTypes.func.isRequired,
    handleCreditMemoSelect: PropTypes.func.isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    handleDealerSelect: PropTypes.func.isRequired,
    handleFirstWorkOrderInput: PropTypes.func.isRequired,
    handleInvoiceRequestInput: PropTypes.func.isRequired,
    handlePinInputChange: PropTypes.func.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    onCreateCreditMemoReport: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default CreditMemoReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/index.js